// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"9a7eb42e","525":"e4a0f15f"}[chunkId] + ".chunk.css";
};